import { User } from '../models/user';

export const getOrganizationDistrictId = (currentUser: User | undefined, paramId: string | undefined): string | undefined => {
  if (currentUser && currentUser.districts.length === 1) return `${currentUser.districts[0].countyAss_id}`;
  if (!paramId && currentUser) return `${currentUser.districts[0].countyAss_id}`;
  return paramId;
};

export const getOrganizationAssociationId = (currentUser: User | undefined, paramId: string | undefined): string | undefined => {
  if (currentUser && currentUser.associations.length === 1) return `${currentUser.associations[0].localAss_id}`;
  if (!paramId && currentUser) return `${currentUser.associations[0].localAss_id}`;
  return paramId;
};

export const getUserAssociations = (currentUser: User | undefined) => {
  if (currentUser && currentUser.associations.length === 1) {
    return [currentUser.associations[0]];
  }
  if (currentUser && currentUser.associations.length > 1) {
    return currentUser.associations;
  }
  return [];
};

export const getUserDistricts = (currentUser: User | undefined) => {
  if (currentUser && currentUser.districts.length === 1) {
    return [currentUser.districts[0]];
  }
  if (currentUser && currentUser.districts.length > 1) {
    return currentUser.districts;
  }
  return [];
};
